<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="900" scrollable>
			<v-card>
				<v-card-title class="h6" v-if="propAdd=='tambah'">Tambah Theme</v-card-title>
				<v-card-title class="h6" v-else>Edit Theme</v-card-title>
				<v-card-text>
					<v-alert v-for="(alert, index) in alertMultiple" v-model="alert.show" :key="index" dismissible type="error" elevation="1">
						{{alert.message}}
					</v-alert>
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-text-field outlined dense v-model="theme_name" label="Nama Theme" class="py-3" background-color="white" :rules="[inputrules.required]"></v-text-field>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-simple-table class="white-row">
								<template v-slot:default>
									<thead class="v-data-table-header">
										<tr>
											<th width="5%" class="text-left">Aksi</th>
											<th width="45%" class="text-left">Nama Section</th>
											<th width="50%" class="text-left">Produk</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(product, index) in productsSelected" :key="product.product_id">
											<td>
												<div class="d-flex">
													<div>
														<v-tooltip bottom>
															<template v-slot:activator="{ on, attrs }">
																<v-btn fab dark x-small depressed color="pink" v-bind="attrs" v-on="on" @click.stop="deleteSection(index)">
																	<v-icon dark>mdi-delete</v-icon>
																</v-btn>
															</template>
															<span>Hapus</span>
														</v-tooltip>
													</div>
												</div>
											</td>
											<td>
												<v-text-field outlined dense v-model="product.data.section_name" label="Nama Section" class="py-3" background-color="white" :rules="[inputrules.required]"></v-text-field>
											</td>
											<td>
												<v-autocomplete :items="productToSellResults" item-text="product_name" item-value="product_id" v-model="product.data.product_id" no-data-text="Tidak ada data" class="py-3 details-mb-0" outlined dense hide-details="auto" background-color="white" multiple :rules="[v => !!(v && v.length) || 'Produk tidak boleh kosong']"></v-autocomplete>
											</td>
										</tr>
									</tbody>
									<tfoot>
									</tfoot>
								</template>
							</v-simple-table>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-card-actions class="px-4 pb-4">
								<v-btn light depressed color="primary" @click="addProduct">
									<v-icon>mdi-plus-circle</v-icon>
									<div class="pl-2 text-capitalize">Tambah Section</div>
								</v-btn>
								<v-spacer></v-spacer>
							</v-card-actions>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="batal">Batal</v-btn>
					<v-btn color="primary" depressed class="text-capitalize" @click="simpan" :disabled="productsSelected.length == 0">Simpan</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'
export default {
	data () {
		return {
			formData: {},
			page: 1,
			limit: "10",
			params: [],
			paramAdd: {
			},
			productsSelected: [],
			theme_name: '',
			theme_id: 0,
		}
	},
	props: {
		value: Boolean,
		propAdd: String,
		edit: String,
		val: Object,
	},
	computed: {
		dialog: {
			get () {
				return this.value
			},
			set (value) {
				this.$emit('input', value)
			}
		},
		...mapState('webReferral', ['productToSellResults', 'response', 'responseError', 'supplierResults', 'alertMultiple']),
	},
	methods: {
		...mapActions('webReferral', ['getProductToSell', 'createTheme', 'getDataTheme']),
		...mapMutations('productList', ['konfirmasiSukses', 'validationError', 'multipleAlert']),

		batal() {
			this.dialog = false
			this.konfirmasiSukses('')
			this.resetForm()
		},
		simpan() {
			var parameter = {
				theme_id: this.theme_id,
				theme_name: this.theme_name,
				section: this.productsSelected,
			}

			this.createTheme(parameter).then( () => {
				if(this.response.code == 200) {
					this.getDataTheme(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))

					this.dialog= false
					this.resetForm()
				} else {
					this.dialog= true
				}
			})
		},
		addProduct() {
			//this.responseError.product = ''
			this.productsSelected.push({
				data: {
					product_id: [],
					section_name: '',
				},
			})
		},
		async getDataProduct() {
			await this.getProductToSell()
		},
		resetForm(){
			this.productsSelected = []
			this.theme_id = 0
			this.theme_name = ''
		},
		deleteSection(index){
			this.productsSelected.splice(index, 1)
		},
	},
	watch: {
		dialog(val) {
			if (val) {
				if (this.propAdd == 'edit') {
					this.theme_id = this.val.web_referral_theme_id
					this.theme_name = this.val.web_referral_theme_name

					if (this.val.detail.length > 0) {
						this.val.detail.map((el) => {
							this.productsSelected.push({
								data: {
									product_id: el.web_referral_theme_detail_product_arr,
									section_name: el.web_referral_theme_detail_section_name,
								},
							})
						})
					}
				}
			}
		}
	},
	created() {
		this.getDataProduct()
	}
}
</script>